import { ISelectOption } from "src/shared/types/field.types";
import { EContractType } from "../types";

export const contractLabels: Record<EContractType, string> = {
  virtual: "Виртуальный",
  complex: "Комплексный",
  agreement: "Доп. соглашение",
};

export const agreementStatusOptions: ISelectOption<boolean>[] = [
  { name: "Не активно", value: false },
  { name: "Действует", value: true },
];

export const agreementOriginalOptions: ISelectOption<boolean>[] = [
  { name: "Отсутствует", value: false },
  { name: "В наличии", value: true },
];
